package com.schoolconnect.app.feature.staff

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFieldRow
import com.schoolconnect.app.designsystem.AppDialogFormGrid
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogValidationSummary
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInfoBg
import com.schoolconnect.app.designsystem.AppInfoBorder
import com.schoolconnect.app.designsystem.AppInfoText
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.list.AdminListFilterBanner
import com.schoolconnect.app.designsystem.list.AdminInfoBanner
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListRowActionBar
import com.schoolconnect.app.designsystem.list.AdminListToolbar
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.designsystem.list.AdminStatusChip
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.repository.systemlookup.SystemLookupRepository
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.toDateComparable
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.edit
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.info_circle
import ischoolconnect.sharedui.generated.resources.mail
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.trash
import ischoolconnect.sharedui.generated.resources.user
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

private fun String.toStaffDisplayDateTime(): String {
    val value = trim()
    if (value.isBlank()) return ""

    val dateParts = value.substringBefore('T').split('-')
    if (dateParts.size != 3) return value

    val year = dateParts[0]
    val month = dateParts[1].toIntOrNull()
    val day = dateParts[2].toIntOrNull()
    if (month == null || day == null || month !in 1..12) return value

    val monthLabel = listOf(
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    )[month - 1]
    val dateLabel = "${day.toString().padStart(2, '0')} $monthLabel $year"
    val timePart = value.substringAfter('T', "").take(5)
    val hour = timePart.substringBefore(':').toIntOrNull()
    val minute = timePart.substringAfter(':', "").toIntOrNull()
    return if (hour != null && minute != null && hour in 0..23 && minute in 0..59) {
        val meridiem = if (hour >= 12) "PM" else "AM"
        val displayHour = when (val normalized = hour % 12) {
            0 -> 12
            else -> normalized
        }
        "$dateLabel, ${displayHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} $meridiem"
    } else {
        dateLabel
    }
}

@Composable
private fun rememberStaffGenderOptions(): List<String> {
    var options by remember { mutableStateOf(emptyList<String>()) }
    LaunchedEffect(Unit) {
        options = SystemLookupRepository.loadCategoryItems("GENDER")
            .getOrDefault(emptyList())
            .mapNotNull { it.displayValue?.trim()?.takeIf(String::isNotBlank) ?: it.code?.trim()?.takeIf(String::isNotBlank) }
            .distinct()
    }
    return options
}

internal val StaffBackground = AppBackground
internal val StaffSurface = AppSurface
internal val StaffBorder = AppBorder
internal val StaffLine = AppLine
internal val StaffNavy = AppNavy
internal val StaffMuted = AppMuted
internal val StaffPrimary = AppPrimary
internal val StaffSuccess = AppSuccess
internal val StaffSuccessBg = AppSuccessSoft
internal val StaffDanger = AppDanger
internal val StaffDangerBg = AppDangerSoft
internal val StaffBlueBg = AppPrimarySoft
internal val StaffBlueText = AppInfoText
internal val StaffPurpleBg = Color(0xFFEFE7FF)
internal val StaffPurpleText = Color(0xFF6B2CE6)
internal val StaffOrangeBg = Color(0xFFFFF0E3)
internal val StaffOrangeText = Color(0xFFF59E0B)
internal val StaffInputBorder = AppBorder
internal val StaffSelectedBg = Color(0xFFEEF5FF)

private val StaffDialogColors = com.schoolconnect.app.designsystem.AppDialogDefaultColors


internal data class StaffPageSummary(
    val pageText: String,
    val pageIndex: Int,
    val pageCount: Int
)

@Composable
internal fun StaffContent(
    state: StaffUiState,
    onEvent: (StaffUiEvent) -> Unit,
    shellRoleCode: String,
    shellSchoolLabel: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    val page = staffPage(state)
    var openActionMenuStaffId by remember { mutableStateOf<String?>(null) }
    var pendingStaffAction by remember { mutableStateOf<StaffPendingAction?>(null) }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }
    var accountMenuExpanded by remember { mutableStateOf(false) }
    val roleLabel = shellRoleLabel(shellRoleCode)
    val roleSubtitle = shellRoleSubtitle(shellRoleCode)
    val initials = shellAvatarInitials(roleLabel)

    LaunchedEffect(page.items) {
        if (openActionMenuStaffId != null && page.items.none { it.id == openActionMenuStaffId }) {
            openActionMenuStaffId = null
        }
    }

    AdminListPageScaffold(
        title = "Manage Staff",
        subtitle = "View and manage school staff master records.",
        breadcrumb = listOf("School Setup", "Manage Records", "Staff"),
        showSummaryCards = false,
        headerActions = {
            ShellTopRightActions(
                roleLabel = roleLabel,
                roleSubtitle = roleSubtitle,
                initials = initials,
                expanded = accountMenuExpanded,
                onExpandedChange = { accountMenuExpanded = it },
                onChangeRole = onChangeRole,
                onLogout = onLogout
            )
        },
        backgroundColor = StaffBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        summaryCards = {},
        bannerAfterToolbar = true,
        banner = {
            val filters = staffFilterLabels(state.filters)
            val staffDialogOpen = state.isAddStaffModalOpen || state.isEditStaffModalOpen
            if (!staffDialogOpen) {
                val hasMessage = state.errorMessage.isNotBlank() || state.infoMessage.isNotBlank()
                if (hasMessage) {
                    StaffBanner(
                        message = state.errorMessage.ifBlank { state.infoMessage },
                        onDismiss = { onEvent(StaffUiEvent.ClearMessages) },
                        isError = state.errorMessage.isNotBlank()
                    )
                }
                AdminListFilterBanner(
                    chips = filters,
                    onClearAll = { onEvent(StaffUiEvent.FiltersReset) },
                    onRemoveChip = { chip ->
                        val next = when {
                            chip.startsWith("Staff role:") -> state.filters.copy(staffRole = "")
                            chip.startsWith("Auth role:") -> state.filters.copy(authRole = "")
                            chip.startsWith("Gender:") -> state.filters.copy(gender = "")
                            chip.startsWith("Status:") -> state.filters.copy(status = "")
                            chip.startsWith("Created:") -> state.filters.copy(createdFrom = "", createdTo = "")
                            else -> state.filters
                        }
                        onEvent(StaffUiEvent.FiltersApplied(next))
                    },
                    onEditFilters = { onEvent(StaffUiEvent.FilterModalOpened) },
                    backgroundColor = Color(0xFFF2F7FF),
                    borderColor = StaffBorder,
                    contentColor = StaffNavy,
                    accentColor = StaffPrimary
                )
            }
        },
        toolbar = {
            AdminListToolbar(
                searchQuery = state.searchQuery,
                onSearchQueryChanged = { onEvent(StaffUiEvent.SearchChanged(it)) },
                searchPlaceholder = "Search by staff ID, name or mobile number...",
                searchWidth = 320.dp,
                surfaceColor = StaffSurface,
                borderColor = StaffBorder,
                searchIconTint = StaffMuted,
                searchTextColor = StaffNavy,
                searchCursorColor = StaffPrimary,
                inlineContent = {
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.authRole.ifBlank { "All Auth Roles" },
                        options = state.authRoleOptions.map { it.label },
                        onSelected = { role ->
                            onEvent(StaffUiEvent.FiltersApplied(state.filters.copy(authRole = role)))
                        },
                        modifier = Modifier.width(164.dp),
                        allOptionLabel = "All Auth Roles",
                        enabled = !state.isAuthRolesLoading && state.authRoleOptions.isNotEmpty()
                    )
                    val genderOptions = rememberStaffGenderOptions()
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.gender.ifBlank { "All Genders" },
                        options = genderOptions,
                        onSelected = { gender ->
                            onEvent(StaffUiEvent.FiltersApplied(state.filters.copy(gender = gender)))
                        },
                        modifier = Modifier.width(136.dp),
                        allOptionLabel = "All Genders",
                        enabled = genderOptions.isNotEmpty()
                    )
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.status.ifBlank { "All Statuses" },
                        options = staffStatusOptions(),
                        onSelected = { status ->
                            onEvent(StaffUiEvent.FiltersApplied(state.filters.copy(status = status)))
                        },
                        modifier = Modifier.width(136.dp),
                        allOptionLabel = "All Statuses"
                    )
                }
            ) {
                AdminListToolbarButton(
                    label = "More Filters",
                    icon = painterResource(Res.drawable.filter),
                    onClick = { onEvent(StaffUiEvent.FilterModalOpened) },
                    width = 148.dp,
                    borderColor = StaffBorder,
                    contentColor = StaffPrimary
                )
                AdminListToolbarButton(
                    label = "Clear",
                    icon = painterResource(Res.drawable.close_x),
                    onClick = { onEvent(StaffUiEvent.FiltersReset) },
                    width = 100.dp,
                    borderColor = StaffBorder,
                    contentColor = StaffPrimary
                )
            }
        },
        table = { tableModifier ->
            AdminListTableCard(
                modifier = tableModifier,
                surfaceColor = StaffSurface,
                borderColor = StaffBorder,
                minContentWidth = 860.dp,
                header = {
                    StaffTableHeader(
                        sortField = state.sortField,
                        sortAscending = state.sortAscending,
                        onSortChanged = { onEvent(StaffUiEvent.SortChanged(it)) }
                    )
                },
                body = {
                    if (state.isLoading) {
                        AdminListTableShimmer(
                            columns = staffTableShimmerColumns(),
                            rowCount = 6,
                            modifier = Modifier.fillMaxWidth()
                        )
                    } else if (page.items.isEmpty()) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .weight(1f),
                            contentAlignment = Alignment.Center
                        ) {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                Text(
                                    text = "No staff found",
                                    color = StaffNavy,
                                    fontWeight = FontWeight.ExtraBold
                                )
                                Spacer(modifier = Modifier.height(6.dp))
                                Text(
                                    text = "Try a different search or filter.",
                                    color = StaffMuted,
                                    fontWeight = FontWeight.Medium
                                )
                            }
                        }
                    } else {
                        AdminListTableBody(
                            modifier = Modifier
                                .fillMaxWidth()
                                .weight(1f),
                            items = page.items,
                            key = { it.id }
                        ) { staff ->
                            StaffRow(
                                row = staff,
                                isActionMenuOpen = openActionMenuStaffId == staff.id,
                                onActionMenuToggle = {
                                    openActionMenuStaffId = if (openActionMenuStaffId == staff.id) null else staff.id
                                },
                                onActionMenuDismiss = {
                                    if (openActionMenuStaffId == staff.id) {
                                        openActionMenuStaffId = null
                                    }
                                },
                                onViewDetails = {
                                    openActionMenuStaffId = null
                                    onEvent(StaffUiEvent.ViewStaff(staff.id))
                                },
                                onEdit = {
                                    openActionMenuStaffId = null
                                    onEvent(StaffUiEvent.EditStaff(staff.id))
                                },
                                onToggleStatus = {
                                    openActionMenuStaffId = null
                                    pendingStaffAction = StaffPendingAction(
                                        staff = staff,
                                        action = StaffPendingActionType.ToggleStatus
                                    )
                                },
                                onDelete = {
                                    openActionMenuStaffId = null
                                    pendingStaffAction = StaffPendingAction(
                                        staff = staff,
                                        action = StaffPendingActionType.Delete
                                    )
                                }
                            )
                            }
                    }
                },
                footer = {
                    StaffFooter(
                        pageText = if (page.totalCount == 0) {
                            "Showing 0 to 0 of 0 staff"
                        } else {
                            "Showing ${page.startIndex} to ${page.endIndex} of ${page.totalCount} staff"
                        },
                        pageIndex = state.paging.pageIndex.coerceAtMost(page.pageCount - 1),
                        pageCount = page.pageCount,
                        onPageChanged = { onEvent(StaffUiEvent.PageChanged(it)) },
                        pageSize = state.paging.pageSize,
                        rowsPerPageExpanded = rowsPerPageExpanded,
                        onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                        onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                        onPageSizeChanged = { onEvent(StaffUiEvent.PageSizeChanged(it)) }
                    )
                }
            )
        },
        bottomAction = {
            AdminListPrimaryActionButton(
                label = "Add Staff",
                icon = painterResource(Res.drawable.plus),
                onClick = { onEvent(StaffUiEvent.AddStaffClicked) },
                backgroundColor = StaffPrimary
            )
        }
    )

    pendingStaffAction?.let { pending ->
        val isDelete = pending.action == StaffPendingActionType.Delete
        val isActive = pending.staff.status == StaffStatusUi.ACTIVE
        val actionLabel = if (isActive) "Inactivate" else "Activate"
        val title = if (isDelete) {
            "Delete Staff"
        } else {
            "$actionLabel Staff"
        }
        val subtitle = if (isDelete) {
            "This will move the staff record to inactive records."
        } else {
            "This will update the staff status without removing the record."
        }
        val bodyText = if (isDelete) {
            "Delete ${pending.staff.staffName}?"
        } else {
            "$actionLabel ${pending.staff.staffName}?"
        }
        AppConfirmationDialog(
            onDismiss = { pendingStaffAction = null },
            title = title,
            subtitle = subtitle,
            bodyText = bodyText,
            confirmLabel = if (isDelete) "Delete" else actionLabel,
            tone = if (isDelete) AppConfirmationDialogTone.Danger else AppConfirmationDialogTone.Primary,
            onConfirm = {
                pendingStaffAction = null
                when (pending.action) {
                    StaffPendingActionType.Delete -> onEvent(StaffUiEvent.DeleteStaff(pending.staff.id))
                    StaffPendingActionType.ToggleStatus -> onEvent(StaffUiEvent.ToggleStatus(pending.staff.id))
                }
            }
        )
    }

    StaffFilterModal(
        open = state.isFilterModalOpen,
        initialValues = state.filters,
        authRoleOptions = state.authRoleOptions,
        onClose = { onEvent(StaffUiEvent.FilterModalClosed) },
        onReset = { onEvent(StaffUiEvent.FiltersReset) },
        onApply = { onEvent(StaffUiEvent.FiltersApplied(it)) }
    )

    StaffFormModal(
        open = state.isAddStaffModalOpen,
        title = "Add Staff",
        subtitle = "Enter the staff details to create a new staff record.",
        initialValues = defaultStaffFormValues(),
        authRoleOptions = state.authRoleOptions,
        classSectionOptions = state.classSectionOptions,
        subjectOptions = state.subjectOptions,
        subjectOptionsByClassSectionId = state.subjectOptionsByClassSectionId,
        isAssignmentOptionsLoading = state.isAssignmentOptionsLoading,
        assignmentOptionsError = state.assignmentOptionsError,
        isSaving = state.isSaving,
        onClose = { onEvent(StaffUiEvent.AddStaffModalClosed) },
        onSave = { onEvent(StaffUiEvent.AddStaffSubmitted(it)) },
        onRetryAssignmentOptions = { onEvent(StaffUiEvent.AssignmentOptionsRetryRequested) },
        saveLabel = "Add",
        apiError = state.errorMessage
    )

    val editingStaff = state.staff.firstOrNull { it.id == state.editingStaffId }
    StaffFormModal(
        open = state.isEditStaffModalOpen && editingStaff != null,
        title = "Edit Staff",
        subtitle = "Update the staff details below.",
        initialValues = state.editingStaffFormValues
            ?: editingStaff?.let { staffFormValuesFrom(it, state.authRoleOptions) }
            ?: defaultStaffFormValues(),
        authRoleOptions = state.authRoleOptions,
        classSectionOptions = state.classSectionOptions,
        subjectOptions = state.subjectOptions,
        subjectOptionsByClassSectionId = state.subjectOptionsByClassSectionId,
        isAssignmentOptionsLoading = state.isAssignmentOptionsLoading || state.isEditingStaffLoading,
        assignmentOptionsError = state.assignmentOptionsError,
        isSaving = state.isSaving || state.isEditingStaffLoading,
        onClose = { onEvent(StaffUiEvent.EditStaffModalClosed) },
        onSave = { onEvent(StaffUiEvent.EditStaffSubmitted(state.editingStaffId, it)) },
        onRetryAssignmentOptions = { onEvent(StaffUiEvent.AssignmentOptionsRetryRequested) },
        saveLabel = "Save",
        apiError = state.errorMessage
    )

    val viewingStaff = state.staff.firstOrNull { it.id == state.viewingStaffId }
    StaffViewModal(
        open = state.isViewStaffModalOpen && viewingStaff != null,
        row = viewingStaff,
        onClose = { onEvent(StaffUiEvent.ViewStaffModalClosed) }
    )
}

@Composable
internal fun StaffTableHeader(
    sortField: StaffSortField,
    sortAscending: Boolean,
    onSortChanged: (StaffSortField) -> Unit
) {
    AdminListSortHeaderRow(
        columns = listOf(
            AdminListSortColumn(
                label = "Staff ID",
                weight = 1.05f,
                selected = sortField == StaffSortField.STAFF_ID,
                ascending = sortAscending,
                onClick = { onSortChanged(StaffSortField.STAFF_ID) }
            ),
            AdminListSortColumn(
                label = "Staff Name",
                weight = 1.45f,
                selected = sortField == StaffSortField.STAFF_NAME,
                ascending = sortAscending,
                onClick = { onSortChanged(StaffSortField.STAFF_NAME) }
            ),
            AdminListSortColumn(
                label = "Staff Role",
                weight = 1.1f,
                selected = sortField == StaffSortField.STAFF_ROLE,
                ascending = sortAscending,
                onClick = { onSortChanged(StaffSortField.STAFF_ROLE) }
            ),
            AdminListSortColumn(
                label = "Auth Role",
                weight = 1.0f,
                selected = sortField == StaffSortField.AUTH_ROLE,
                ascending = sortAscending,
                onClick = { onSortChanged(StaffSortField.AUTH_ROLE) }
            ),
            AdminListSortColumn(
                label = "Mobile Number",
                weight = 1.25f,
                selected = sortField == StaffSortField.MOBILE_NUMBER,
                ascending = sortAscending,
                onClick = { onSortChanged(StaffSortField.MOBILE_NUMBER) }
            ),
            AdminListSortColumn(
                label = "Status",
                weight = 0.8f,
                selected = sortField == StaffSortField.STATUS,
                ascending = sortAscending,
                onClick = { onSortChanged(StaffSortField.STATUS) }
            )
        ),
        actionsLabel = "Actions",
        actionsWeight = 0.95f,
        horizontalPadding = 24.dp,
        height = 44.dp
    )
}

@Composable
internal fun StaffRow(
    row: StaffRowUi,
    isActionMenuOpen: Boolean,
    onActionMenuToggle: () -> Unit,
    onActionMenuDismiss: () -> Unit,
    onViewDetails: () -> Unit,
    onEdit: () -> Unit,
    onToggleStatus: () -> Unit,
    onDelete: () -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .onViewDoubleClick(onViewDetails)
                .heightIn(min = 52.dp)
                .padding(horizontal = 24.dp, vertical = 4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            StaffCellText(row.staffId, 1.05f)
            StaffCellText(row.staffName, 1.45f)
            StaffRoleChip(row.roleTitle.ifBlank { staffRoleLabel(row.staffRole) }, 1.1f)
            StaffAuthRoleChip(staffAuthRoleDisplayLabel(row.authRoleCode, row.authRole), 1.0f)
            StaffCellText(row.mobileNumber, 1.25f)
            Box(
                modifier = Modifier.weight(0.8f),
                contentAlignment = Alignment.CenterStart
            ) {
                StaffStatusChip(row.status)
            }
            Box(
                modifier = Modifier.weight(0.95f),
                contentAlignment = Alignment.Center
            ) {
                AdminListRowActionBar(
                    isActive = row.status == StaffStatusUi.ACTIVE,
                    expanded = isActionMenuOpen,
                    onExpandedChange = { onActionMenuToggle() },
                    onDismissRequest = onActionMenuDismiss,
                    onView = onViewDetails,
                    onEdit = onEdit,
                    onToggleStatus = onToggleStatus,
                    onDelete = onDelete,
                    width = 190.dp,
                    surfaceColor = StaffSurface,
                    borderColor = StaffBorder
                )
            }
        }
        HorizontalDivider(color = StaffLine, modifier = Modifier.padding(horizontal = 24.dp))
    }
}

@Composable
internal fun StaffStatusChip(status: StaffStatusUi) {
    val color = when (status) {
        StaffStatusUi.ACTIVE -> StaffSuccess
        StaffStatusUi.INACTIVE -> StaffDanger
    }
    AdminListTableBodyText(
        text = staffStatusLabel(status),
        color = color
    )
}

@Composable
internal fun RowScope.StaffRoleChip(role: String, weight: Float) {
    Box(modifier = Modifier.weight(weight)) {
        AdminListTableBodyText(
            text = role,
            color = StaffNavy,
            modifier = Modifier.fillMaxWidth()
        )
    }
}

@Composable
internal fun RowScope.StaffAuthRoleChip(role: String, weight: Float) {
    AdminListTableBodyText(
        text = role,
        modifier = Modifier.weight(weight)
    )
}

@Composable
internal fun RowScope.StaffCellText(text: String, weight: Float) {
    Box(
        modifier = Modifier.weight(weight),
        contentAlignment = Alignment.CenterStart
    ) {
        AdminListTableBodyText(
            text = text,
            color = StaffNavy,
            modifier = Modifier.fillMaxWidth()
        )
    }
}

@Composable
internal fun StaffFooter(
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    pageSize: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit
) {
    AdminListFooter(
        pageText = pageText,
        pageIndex = pageIndex,
        pageCount = pageCount,
        onPageChanged = onPageChanged,
        pageSize = pageSize,
        rowsPerPageExpanded = rowsPerPageExpanded,
        onRowsPerPageToggle = onRowsPerPageToggle,
        onRowsPerPageDismiss = onRowsPerPageDismiss,
        onPageSizeChanged = onPageSizeChanged,
        footerColor = StaffMuted,
        borderColor = StaffBorder,
        surfaceColor = StaffSurface,
        primaryColor = StaffPrimary,
        navyColor = StaffNavy,
        mutedColor = StaffMuted
    )
}

@Composable
internal fun StaffBanner(
    message: String,
    onDismiss: () -> Unit,
    isError: Boolean
) {
    AdminInfoBanner(
        message = message,
        onDismiss = onDismiss,
        leadingIcon = painterResource(Res.drawable.info_circle),
        backgroundColor = Color(0xFFF2F7FF),
        borderColor = Color(0xFFD9E7FF),
        contentColor = StaffNavy,
        accentColor = StaffPrimary,
        isError = isError
    )
}

@Composable
internal fun StaffFilterModal(
    open: Boolean,
    initialValues: StaffFilterFormValues,
    authRoleOptions: List<StaffAuthRoleOption>,
    onClose: () -> Unit,
    onReset: () -> Unit,
    onApply: (StaffFilterFormValues) -> Unit
) {
    if (!open) return

    val genderOptions = rememberStaffGenderOptions()

    var searchQuery by remember(initialValues) { mutableStateOf(initialValues.searchQuery) }
    var staffRole by remember(initialValues) { mutableStateOf(initialValues.staffRole) }
    var authRole by remember(initialValues) { mutableStateOf(initialValues.authRole) }
    var gender by remember(initialValues) { mutableStateOf(initialValues.gender) }
    var status by remember(initialValues) { mutableStateOf(initialValues.status) }
    var createdFrom by remember(initialValues) { mutableStateOf(initialValues.createdFrom) }
    var createdTo by remember(initialValues) { mutableStateOf(initialValues.createdTo) }
    var authExpanded by remember { mutableStateOf(false) }
    var genderExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(open, initialValues) {
        if (open) {
            searchQuery = initialValues.searchQuery
            staffRole = initialValues.staffRole
            authRole = initialValues.authRole
            gender = initialValues.gender
            status = initialValues.status
            createdFrom = initialValues.createdFrom
            createdTo = initialValues.createdTo
        }
    }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Wide,
        colors = StaffDialogColors,
        maxDialogHeight = 900.dp
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppDialogHeader(
                title = "Filter Staff",
                subtitle = "Narrow down the staff list.",
                onClose = onClose,
                colors = StaffDialogColors,
                icon = Res.drawable.filter,
                iconContentDescription = "Filter staff"
            )
            HorizontalDivider(color = StaffBorder)
            AppDialogFormGrid(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                val compact = it
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .verticalScroll(rememberScrollState())
                        .padding(horizontal = 28.dp, vertical = 24.dp),
                    verticalArrangement = Arrangement.spacedBy(22.dp)
                ) {
                    if (compact) {
                        Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
                            StaffFilterField("Staff Role") {
                                AppDialogTextField(
                                    value = staffRole,
                                    onValueChange = { staffRole = it },
                                    placeholder = "Enter staff role",
                                    colors = StaffDialogColors
                                )
                            }
                            StaffFilterField("Auth Role") {
                                AppDialogSelectField(
                                    value = authRole,
                                    placeholder = "Select Auth Role",
                                    expanded = authExpanded,
                                    options = authRoleOptions.map { it.label },
                                    onToggleExpanded = { authExpanded = !authExpanded },
                                    onDismissExpanded = { authExpanded = false },
                                    onSelected = { authRole = it },
                                    colors = StaffDialogColors
                                )
                            }
                            StaffFilterField("Gender") {
                                AppDialogSelectField(
                                    value = gender,
                                    placeholder = "Select Gender",
                                    expanded = genderExpanded,
                                    options = genderOptions,
                                    onToggleExpanded = { genderExpanded = !genderExpanded },
                                    onDismissExpanded = { genderExpanded = false },
                                    onSelected = { gender = it },
                                    colors = StaffDialogColors
                                )
                            }
                            StaffFilterField("Status") {
                                AppDialogSelectField(
                                    value = status,
                                    placeholder = "Select Status",
                                    expanded = statusExpanded,
                                    options = staffStatusOptions(),
                                    onToggleExpanded = { statusExpanded = !statusExpanded },
                                    onDismissExpanded = { statusExpanded = false },
                                    onSelected = { status = it },
                                    colors = StaffDialogColors
                                )
                            }
                        }
                    } else {
                        AppDialogFieldRow(spacing = 28.dp) {
                            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(22.dp)) {
                                StaffFilterField("Staff Role") {
                                    AppDialogTextField(
                                        value = staffRole,
                                        onValueChange = { staffRole = it },
                                        placeholder = "Enter staff role",
                                        colors = StaffDialogColors
                                    )
                                }
                                StaffFilterField("Gender") {
                                    AppDialogSelectField(
                                        value = gender,
                                        placeholder = "Select Gender",
                                        expanded = genderExpanded,
                                        options = genderOptions,
                                        onToggleExpanded = { genderExpanded = !genderExpanded },
                                        onDismissExpanded = { genderExpanded = false },
                                        onSelected = { gender = it },
                                        colors = StaffDialogColors
                                    )
                                }
                            }
                            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(22.dp)) {
                                StaffFilterField("Auth Role") {
                                    AppDialogSelectField(
                                        value = authRole,
                                        placeholder = "Select Auth Role",
                                        expanded = authExpanded,
                                        options = authRoleOptions.map { it.label },
                                        onToggleExpanded = { authExpanded = !authExpanded },
                                        onDismissExpanded = { authExpanded = false },
                                        onSelected = { authRole = it },
                                        colors = StaffDialogColors
                                    )
                                }
                                StaffFilterField("Status") {
                                    AppDialogSelectField(
                                        value = status,
                                        placeholder = "Select Status",
                                        expanded = statusExpanded,
                                        options = staffStatusOptions(),
                                        onToggleExpanded = { statusExpanded = !statusExpanded },
                                        onDismissExpanded = { statusExpanded = false },
                                        onSelected = { status = it },
                                        colors = StaffDialogColors
                                    )
                                }
                            }
                        }
                    }

                    AppDialogFieldRow(spacing = 28.dp) {
                        Column(modifier = Modifier.weight(1f)) {
                            StaffFilterField("Created Date From") {
                                AppDialogDateField(
                                    value = createdFrom,
                                    onValueChange = { createdFrom = it },
                                    placeholder = "DD MMM YYYY",
                                    colors = StaffDialogColors
                                )
                            }
                        }
                        Column(modifier = Modifier.weight(1f)) {
                            StaffFilterField("Created Date To") {
                                AppDialogDateField(
                                    value = createdTo,
                                    onValueChange = { createdTo = it },
                                    placeholder = "DD MMM YYYY",
                                    colors = StaffDialogColors
                                )
                            }
                        }
                    }

                    if (!isValidStaffDateRange(createdFrom, createdTo)) {
                        AppDialogErrorMessage(
                            message = "Created Date From must be on or before Created Date To.",
                            colors = StaffDialogColors
                        )
                    }

                }
            }
            HorizontalDivider(color = StaffBorder)
            AppDialogFooter(
                actions = listOf(
                    AppDialogFooterAction(
                        label = "Cancel",
                        onClick = onClose,
                        style = AppDialogActionStyle.Secondary,
                        width = 148.dp
                    ),
                    AppDialogFooterAction(
                        label = "Reset",
                        onClick = {
                            searchQuery = ""
                            staffRole = ""
                            authRole = ""
                            gender = ""
                            status = ""
                            createdFrom = ""
                            createdTo = ""
                            authExpanded = false
                            genderExpanded = false
                            statusExpanded = false
                            onReset()
                        },
                        style = AppDialogActionStyle.Secondary,
                        width = 148.dp
                    ),
                    AppDialogFooterAction(
                        label = "Apply",
                        onClick = {
                            if (isValidStaffDateRange(createdFrom, createdTo)) {
                                onApply(
                                    StaffFilterFormValues(
                                        searchQuery = searchQuery.trim(),
                                        staffRole = staffRole.trim(),
                                        authRole = authRole.trim(),
                                        gender = gender.trim(),
                                        status = status.trim(),
                                        createdFrom = createdFrom.trim(),
                                        createdTo = createdTo.trim()
                                    )
                                )
                            }
                        },
                        style = AppDialogActionStyle.Primary,
                        width = 168.dp
                    )
                ),
                colors = StaffDialogColors,
                horizontalArrangement = Arrangement.End
            )
        }
    }
}

private fun isValidStaffDateRange(from: String, to: String): Boolean {
    val fromComparable = toDateComparable(from)
    val toComparable = toDateComparable(to)
    return when {
        from.isBlank() || to.isBlank() -> true
        fromComparable == null || toComparable == null -> false
        else -> fromComparable <= toComparable
    }
}

@Composable
private fun StaffFilterField(
    label: String,
    field: @Composable () -> Unit
) {
    AppDialogFieldColumn(
        label = label,
        colors = StaffDialogColors,
        field = field
    )
}

@Composable
internal fun StaffFormModal(
    open: Boolean,
    title: String,
    subtitle: String,
    initialValues: StaffFormValues,
    authRoleOptions: List<StaffAuthRoleOption>,
    classSectionOptions: List<StaffClassSectionOption>,
    subjectOptions: List<StaffSubjectOption>,
    subjectOptionsByClassSectionId: Map<String, List<StaffSubjectOption>>,
    isAssignmentOptionsLoading: Boolean,
    assignmentOptionsError: String = "",
    isSaving: Boolean,
    apiError: String = "",
    onClose: () -> Unit,
    onSave: (StaffFormValues) -> Unit,
    onRetryAssignmentOptions: () -> Unit = {},
    saveLabel: String
) {
    if (!open) return

    val genderOptions = rememberStaffGenderOptions()

    var staffId by remember(initialValues) { mutableStateOf(initialValues.staffId) }
    var staffName by remember(initialValues) { mutableStateOf(initialValues.staffName) }
    var staffRole by remember(initialValues) { mutableStateOf(initialValues.staffRole) }
    var authRole by remember(initialValues) { mutableStateOf(initialValues.authRole) }
    var mobileNumber by remember(initialValues) { mutableStateOf(initialValues.mobileNumber) }
    var gender by remember(initialValues) { mutableStateOf(initialValues.gender) }
    var emailAddress by remember(initialValues) { mutableStateOf(initialValues.emailAddress) }
    var status by remember(initialValues) { mutableStateOf(initialValues.status.ifBlank { "Active" }) }
    val isAddForm = saveLabel.equals("Add", ignoreCase = true)
    var teachingAssignments by remember(initialValues, saveLabel) {
        mutableStateOf(
            initialValues.teachingAssignments.ifEmpty {
                if (isAddForm) listOf(StaffTeachingAssignmentUi()) else emptyList()
            }
        )
    }
    var hasSubmitted by remember(initialValues, saveLabel) { mutableStateOf(!saveLabel.equals("Add", ignoreCase = true)) }
    var authExpanded by remember { mutableStateOf(false) }
    var genderExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(open, initialValues) {
        if (open) {
            staffId = initialValues.staffId
            staffName = initialValues.staffName
            staffRole = initialValues.staffRole
            authRole = initialValues.authRole
            mobileNumber = initialValues.mobileNumber
            gender = initialValues.gender
            emailAddress = initialValues.emailAddress
            status = initialValues.status.ifBlank { "Active" }
            teachingAssignments = initialValues.teachingAssignments.ifEmpty {
                if (isAddForm) listOf(StaffTeachingAssignmentUi()) else emptyList()
            }
            hasSubmitted = !saveLabel.equals("Add", ignoreCase = true)
        }
    }

    val formValues = StaffFormValues(
        staffId = staffId,
        staffName = staffName,
        staffRole = staffRole,
        authRole = authRole,
        mobileNumber = mobileNumber,
        gender = gender,
        emailAddress = emailAddress,
        status = status,
        teachingAssignments = teachingAssignments
    )
    val validation = remember(hasSubmitted, formValues) {
        if (hasSubmitted) validateStaffEditor(formValues) else StaffFormValidationErrors()
    }
    fun errorFor(label: String): String = when (label) {
        "Staff ID" -> validation.staffId
        "Staff Name" -> validation.staffName
        "Staff Role" -> validation.staffRole
        "Auth Role" -> validation.authRole
        "Mobile Number" -> validation.mobileNumber
        "Gender" -> validation.gender
        "Email Address" -> validation.emailAddress
        "Status" -> validation.status
        else -> ""
    }

    AppDialogScaffold(
        onDismiss = { if (!isSaving) onClose() },
        dismissOnClickOutside = false,
        size = AppDialogSize.Wide,
        colors = StaffDialogColors,
        maxDialogHeight = 920.dp,
        isLoading = isSaving,
        loadingTitle = if (saveLabel.equals("Add", ignoreCase = true)) "Adding staff" else "Saving staff"
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppDialogHeader(
                title = title,
                subtitle = subtitle,
                onClose = { if (!isSaving) onClose() },
                colors = StaffDialogColors,
                icon = null
            )
            AppDialogValidationSummary(
                errors = listOf(validation.staffId, validation.staffName, validation.staffRole, validation.authRole, validation.mobileNumber, validation.gender, validation.emailAddress, validation.status),
                colors = StaffDialogColors,
                modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp)
            )
            AppDialogErrorMessage(
                message = apiError,
                colors = StaffDialogColors,
                modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp)
            )
            HorizontalDivider(color = StaffBorder)
            AppDialogBody(
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(max = 560.dp),
                colors = StaffDialogColors,
                horizontalPadding = 28.dp,
                verticalPadding = 24.dp
            ) { compact ->
                Column(verticalArrangement = Arrangement.spacedBy(22.dp)) {
                    if (compact) {
                        Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
                            StaffFormField(label = "Staff ID", required = true, error = errorFor("Staff ID")) {
                                AppDialogTextField(
                                    value = staffId,
                                    onValueChange = { staffId = it },
                                    placeholder = "Enter staff ID",
                                    colors = StaffDialogColors,
                                    error = errorFor("Staff ID")
                                )
                            }
                            StaffFormField(label = "Staff Name", required = true, error = errorFor("Staff Name")) {
                                AppDialogTextField(
                                    value = staffName,
                                    onValueChange = { staffName = it },
                                    placeholder = "Enter staff name",
                                    colors = StaffDialogColors,
                                    error = errorFor("Staff Name")
                                )
                            }
                            StaffFormField(label = "Staff Role", required = true, error = errorFor("Staff Role")) {
                                AppDialogTextField(
                                    value = staffRole,
                                    onValueChange = { staffRole = it },
                                    placeholder = "Enter staff role",
                                    colors = StaffDialogColors,
                                    error = errorFor("Staff Role")
                                )
                            }
                            StaffFormField(label = "Auth Role", required = true, error = errorFor("Auth Role")) {
                                AppDialogSelectField(
                                    value = authRole,
                                    placeholder = "Select auth role",
                                    expanded = authExpanded,
                                    options = authRoleOptions.map { it.label },
                                    onToggleExpanded = { authExpanded = !authExpanded },
                                    onDismissExpanded = { authExpanded = false },
                                    onSelected = { authRole = it },
                                    colors = StaffDialogColors,
                                    error = errorFor("Auth Role")
                                )
                            }
                            StaffFormField(label = "Mobile Number", required = true, error = errorFor("Mobile Number")) {
                                AppDialogTextField(
                                    value = mobileNumber,
                                    onValueChange = { mobileNumber = it.filter(Char::isDigit).take(10) },
                                    placeholder = "Enter mobile number",
                                    colors = StaffDialogColors,
                                    error = errorFor("Mobile Number")
                                )
                            }
                            StaffFormField(label = "Gender", required = true, error = errorFor("Gender")) {
                                AppDialogSelectField(
                                    value = gender,
                                    placeholder = "Select gender",
                                    expanded = genderExpanded,
                                    options = genderOptions,
                                    onToggleExpanded = { genderExpanded = !genderExpanded },
                                    onDismissExpanded = { genderExpanded = false },
                                    onSelected = { gender = it },
                                    colors = StaffDialogColors,
                                    error = errorFor("Gender")
                                )
                            }
                            StaffFormField(label = "Email Address", required = true, error = errorFor("Email Address")) {
                                AppDialogTextField(
                                    value = emailAddress,
                                    onValueChange = { emailAddress = it },
                                    placeholder = "Enter email address",
                                    colors = StaffDialogColors,
                                    error = errorFor("Email Address"),
                                    leadingIcon = {
                                        Icon(
                                            painter = painterResource(Res.drawable.mail),
                                            contentDescription = null,
                                            tint = StaffMuted,
                                            modifier = Modifier.size(18.dp)
                                        )
                                    }
                                )
                            }
                            if (!saveLabel.equals("Add", ignoreCase = true)) {
                                StaffFormField(label = "Status", required = true, error = errorFor("Status")) {
                                    AppDialogSelectField(
                                        value = status,
                                        placeholder = "Select status",
                                        expanded = statusExpanded,
                                        options = staffStatusOptions(),
                                        onToggleExpanded = { statusExpanded = !statusExpanded },
                                        onDismissExpanded = { statusExpanded = false },
                                        onSelected = { status = it },
                                        colors = StaffDialogColors,
                                        error = errorFor("Status")
                                    )
                                }
                            }
                        }
                    } else {
                        AppDialogFieldRow(spacing = 28.dp) {
                            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(22.dp)) {
                                StaffFormField(label = "Staff ID", required = true, error = errorFor("Staff ID")) {
                                    AppDialogTextField(
                                        value = staffId,
                                        onValueChange = { staffId = it },
                                        placeholder = "Enter staff ID",
                                        colors = StaffDialogColors,
                                        error = errorFor("Staff ID")
                                    )
                                }
                                StaffFormField(label = "Staff Role", required = true, error = errorFor("Staff Role")) {
                                    AppDialogTextField(
                                        value = staffRole,
                                        onValueChange = { staffRole = it },
                                        placeholder = "Enter staff role",
                                        colors = StaffDialogColors,
                                        error = errorFor("Staff Role")
                                    )
                                }
                                StaffFormField(label = "Mobile Number", required = true, error = errorFor("Mobile Number")) {
                                    AppDialogTextField(
                                        value = mobileNumber,
                                        onValueChange = { mobileNumber = it.filter(Char::isDigit).take(10) },
                                        placeholder = "Enter mobile number",
                                        colors = StaffDialogColors,
                                        error = errorFor("Mobile Number")
                                    )
                                }
                            }
                            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(22.dp)) {
                                StaffFormField(label = "Staff Name", required = true, error = errorFor("Staff Name")) {
                                    AppDialogTextField(
                                        value = staffName,
                                        onValueChange = { staffName = it },
                                        placeholder = "Enter staff name",
                                        colors = StaffDialogColors,
                                        error = errorFor("Staff Name")
                                    )
                                }
                                StaffFormField(label = "Auth Role", required = true, error = errorFor("Auth Role")) {
                                    AppDialogSelectField(
                                        value = authRole,
                                        placeholder = "Select auth role",
                                        expanded = authExpanded,
                                        options = authRoleOptions.map { it.label },
                                        onToggleExpanded = { authExpanded = !authExpanded },
                                        onDismissExpanded = { authExpanded = false },
                                        onSelected = { authRole = it },
                                        colors = StaffDialogColors,
                                        error = errorFor("Auth Role")
                                    )
                                }
                                StaffFormField(label = "Gender", required = true, error = errorFor("Gender")) {
                                    AppDialogSelectField(
                                        value = gender,
                                        placeholder = "Select gender",
                                        expanded = genderExpanded,
                                        options = genderOptions,
                                        onToggleExpanded = { genderExpanded = !genderExpanded },
                                        onDismissExpanded = { genderExpanded = false },
                                        onSelected = { gender = it },
                                        colors = StaffDialogColors,
                                        error = errorFor("Gender")
                                    )
                                }
                            }
                        }

                        AppDialogFieldRow(spacing = 28.dp) {
                            Column(modifier = Modifier.weight(1f)) {
                            StaffFormField(label = "Email Address", required = true, error = errorFor("Email Address")) {
                                    AppDialogTextField(
                                        value = emailAddress,
                                        onValueChange = { emailAddress = it },
                                        placeholder = "Enter email address",
                                        colors = StaffDialogColors,
                                        error = errorFor("Email Address"),
                                        leadingIcon = {
                                            Icon(
                                                painter = painterResource(Res.drawable.mail),
                                                contentDescription = null,
                                                tint = StaffMuted,
                                                modifier = Modifier.size(18.dp)
                                            )
                                        }
                                    )
                                }
                            }
                            if (!saveLabel.equals("Add", ignoreCase = true)) {
                                Column(modifier = Modifier.weight(1f)) {
                                    StaffFormField(label = "Status", required = true, error = errorFor("Status")) {
                                        AppDialogSelectField(
                                            value = status,
                                            placeholder = "Select status",
                                            expanded = statusExpanded,
                                            options = staffStatusOptions(),
                                            onToggleExpanded = { statusExpanded = !statusExpanded },
                                            onDismissExpanded = { statusExpanded = false },
                                            onSelected = { status = it },
                                            colors = StaffDialogColors,
                                            error = errorFor("Status")
                                        )
                                    }
                                }
                            } else {
                                Spacer(modifier = Modifier.weight(1f))
                            }
                        }

                        TeachingAssignmentsEditor(
                            assignments = teachingAssignments,
                            classSectionOptions = classSectionOptions,
                            subjectOptions = subjectOptions,
                            subjectOptionsByClassSectionId = subjectOptionsByClassSectionId,
                            isLoading = isAssignmentOptionsLoading,
                            error = assignmentOptionsError,
                            onRetry = onRetryAssignmentOptions,
                            onAssignmentsChanged = { teachingAssignments = it }
                        )
                    }
                }
            }
            HorizontalDivider(color = StaffBorder)
            AppDialogFooter(
                actions = listOf(
                    AppDialogFooterAction(
                        label = "Cancel",
                        onClick = { if (!isSaving) onClose() },
                        style = AppDialogActionStyle.Secondary,
                        width = 152.dp,
                        enabled = !isSaving
                    ),
                    AppDialogFooterAction(
                        label = if (isSaving) "Saving..." else saveLabel,
                        onClick = {
                            hasSubmitted = true
                            if (!isSaving && !validateStaffEditor(formValues).hasAnyError) {
                                onSave(
                                    StaffFormValues(
                                        staffId = staffId.trim(),
                                        staffName = staffName.trim(),
                                        staffRole = staffRole.trim(),
                                        authRole = authRole.trim(),
                                        mobileNumber = mobileNumber.trim(),
                                        gender = gender.trim(),
                                        emailAddress = emailAddress.trim(),
                                        status = status.trim(),
                                        teachingAssignments = teachingAssignments
                                    )
                                )
                            }
                        },
                        style = AppDialogActionStyle.Primary,
                        enabled = !isSaving,
                        width = 152.dp
                    )
                ),
                colors = StaffDialogColors,
                horizontalArrangement = Arrangement.End
            )
        }
    }
}

@Composable
private fun TeachingAssignmentsEditor(
    assignments: List<StaffTeachingAssignmentUi>,
    classSectionOptions: List<StaffClassSectionOption>,
    subjectOptions: List<StaffSubjectOption>,
    subjectOptionsByClassSectionId: Map<String, List<StaffSubjectOption>>,
    isLoading: Boolean,
    error: String,
    onRetry: () -> Unit,
    onAssignmentsChanged: (List<StaffTeachingAssignmentUi>) -> Unit
) {
    var expandedSubjectIndex by remember { mutableStateOf<Int?>(null) }
    val duplicateClassSectionIds = assignments
        .map { it.classSectionId }
        .filter { it.isNotBlank() }
        .groupingBy { it }
        .eachCount()
        .filterValues { it > 1 }
        .keys
    val assignedClassSectionIds = assignments.map { it.classSectionId }.filter { it.isNotBlank() }.toSet()
    val hasUnassignedClassSections = classSectionOptions.any { it.id !in assignedClassSectionIds }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 8.dp),
        verticalArrangement = Arrangement.spacedBy(14.dp)
    ) {
        HorizontalDivider(color = StaffBorder)
        Text(
            text = "Teaching Assignment",
            style = MaterialTheme.typography.titleLarge,
            fontWeight = FontWeight.Bold,
            color = StaffNavy,
            modifier = Modifier.padding(top = 8.dp)
        )
        Text(
            text = "Optional. Assign classes and subjects for this staff member.",
            style = MaterialTheme.typography.bodySmall,
            color = StaffMuted
        )

        if (isLoading) {
            Text("Loading classes and subjects…", color = StaffMuted)
        } else if (classSectionOptions.isEmpty() || subjectOptions.isEmpty()) {
            Text(
                text = error.ifBlank { "Class and subject options are unavailable." },
                style = MaterialTheme.typography.bodySmall,
                color = StaffDanger
            )
            AppOutlinedButton(onClick = onRetry, shape = RoundedCornerShape(8.dp)) {
                Text("Retry", color = StaffPrimary, fontWeight = FontWeight.SemiBold)
            }
        } else {
            if (error.isNotBlank()) {
                Text(error, style = MaterialTheme.typography.bodySmall, color = StaffDanger)
                AppOutlinedButton(onClick = onRetry, shape = RoundedCornerShape(8.dp)) {
                    Text("Retry", color = StaffPrimary, fontWeight = FontWeight.SemiBold)
                }
            }
            assignments.forEachIndexed { index, assignment ->
                Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                    AppDialogFieldRow(
                        modifier = Modifier.fillMaxWidth(),
                        spacing = 16.dp
                    ) {
                        Column(modifier = Modifier.weight(1.05f)) {
                            StaffFormField(label = "Class & Section") {
                                val selected = classSectionOptions.firstOrNull { it.id == assignment.classSectionId }
                                val classSectionChoices = classSectionOptions.filter { option ->
                                    option.id == assignment.classSectionId || assignments
                                        .withIndex()
                                        .none { (otherIndex, other) -> otherIndex != index && other.classSectionId == option.id }
                                }
                                var expanded by remember(index) { mutableStateOf(false) }
                                AppDialogSelectField(
                                    value = selected?.label.orEmpty(),
                                    placeholder = "Select class & section",
                                    expanded = expanded,
                                    options = classSectionChoices.map { it.label },
                                    onToggleExpanded = { expanded = !expanded },
                                    onDismissExpanded = { expanded = false },
                                    onSelected = { label ->
                                        val option = classSectionChoices.firstOrNull { it.label == label }
                                        onAssignmentsChanged(
                                            assignments.mapIndexed { itemIndex, item ->
                                                if (itemIndex == index) item.copy(
                                                    classSectionId = option?.id.orEmpty(),
                                                    subjectIds = emptyList()
                                                ) else item
                                            }
                                        )
                                    },
                                    colors = StaffDialogColors,
                                    error = if (assignment.classSectionId in duplicateClassSectionIds) "This class & section is assigned more than once." else ""
                                )
                            }
                        }
                        Column(modifier = Modifier.weight(1.35f)) {
                            StaffFormField(label = "Subject") {
                                val assignmentSubjectOptions = subjectOptionsByClassSectionId[assignment.classSectionId].orEmpty()
                                StaffSubjectMultiSelect(
                                    selectedIds = assignment.subjectIds.filter { id -> assignmentSubjectOptions.any { it.id == id } },
                                    options = assignmentSubjectOptions,
                                    expanded = expandedSubjectIndex == index,
                                    onToggleExpanded = {
                                        expandedSubjectIndex = if (expandedSubjectIndex == index) null else index
                                    },
                                    onDismissExpanded = { expandedSubjectIndex = null },
                                    onSelectedIdsChanged = { nextIds ->
                                        onAssignmentsChanged(
                                            assignments.mapIndexed { itemIndex, item ->
                                                if (itemIndex == index) item.copy(subjectIds = nextIds) else item
                                            }
                                        )
                                    }
                                )
                            }
                        }
                        Column(modifier = Modifier.weight(0.7f)) {
                            StaffFormField(label = "Class Teacher") {
                                Box(
                                    modifier = Modifier.fillMaxWidth().height(56.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Checkbox(
                                        checked = assignment.isClassTeacher,
                                        onCheckedChange = { checked ->
                                            onAssignmentsChanged(
                                                assignments.mapIndexed { itemIndex, item ->
                                                    if (itemIndex == index) item.copy(isClassTeacher = checked == true) else item
                                                }
                                            )
                                        }
                                    )
                                }
                            }
                        }
                        Column(
                            modifier = Modifier.width(48.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            // Reserve the same label and field-spacing row as the
                            // neighboring controls so the delete action is centered
                            // against the 56dp field controls.
                            Spacer(Modifier.height(32.dp))
                            Box(
                                modifier = Modifier.height(56.dp),
                                contentAlignment = Alignment.Center
                            ) {
                                IconButton(
                                    onClick = {
                                        expandedSubjectIndex = null
                                        onAssignmentsChanged(assignments.filterIndexed { itemIndex, _ -> itemIndex != index })
                                    },
                                    enabled = assignments.size > 1
                                ) {
                                    Icon(
                                        painter = painterResource(Res.drawable.trash),
                                        contentDescription = "Remove assignment",
                                        tint = if (assignments.size > 1) StaffNavy else StaffMuted
                                    )
                                }
                            }
                        }
                    }
                }
            }

            AppOutlinedButton(
                onClick = { onAssignmentsChanged(assignments + StaffTeachingAssignmentUi()) },
                shape = RoundedCornerShape(8.dp),
                enabled = hasUnassignedClassSections
            ) {
                Text("+  Add Assignment", color = StaffPrimary, fontWeight = FontWeight.SemiBold)
            }
        }
    }
}

@Composable
private fun StaffSubjectMultiSelect(
    selectedIds: List<String>,
    options: List<StaffSubjectOption>,
    expanded: Boolean,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onSelectedIdsChanged: (List<String>) -> Unit
) {
    Box {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .height(40.dp)
                .clickable(onClick = onToggleExpanded),
            shape = RoundedCornerShape(8.dp),
            color = StaffSurface,
            border = BorderStroke(1.dp, if (expanded) StaffPrimary else StaffInputBorder)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().padding(start = 12.dp, end = 10.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (selectedIds.isEmpty()) {
                    Text(
                        text = "Select subjects",
                        color = StaffMuted,
                        style = MaterialTheme.typography.bodyMedium,
                        modifier = Modifier.weight(1f)
                    )
                } else {
                    Row(
                        modifier = Modifier
                            .weight(1f)
                            .horizontalScroll(rememberScrollState())
                            .padding(vertical = 8.dp),
                        horizontalArrangement = Arrangement.spacedBy(6.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        selectedIds.mapNotNull { id -> options.firstOrNull { it.id == id } }.forEach { option ->
                            Surface(
                                color = StaffSelectedBg,
                                shape = RoundedCornerShape(6.dp),
                                border = BorderStroke(1.dp, StaffBorder)
                            ) {
                                Row(
                                    modifier = Modifier.padding(horizontal = 9.dp, vertical = 5.dp),
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.spacedBy(6.dp)
                                ) {
                                    Text(
                                        text = option.label,
                                        color = StaffNavy,
                                        style = MaterialTheme.typography.bodySmall,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                    Box(
                                        modifier = Modifier
                                            .size(20.dp)
                                            .clickable {
                                                onSelectedIdsChanged(selectedIds - option.id)
                                            },
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.close_x),
                                            contentDescription = "Remove ${option.label}",
                                            tint = StaffNavy,
                                            modifier = Modifier.size(12.dp)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
                Box(
                    modifier = Modifier.size(28.dp),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.chevron_down),
                        contentDescription = "Open subject options",
                        tint = StaffNavy,
                        modifier = Modifier.size(20.dp).rotate(if (expanded) 180f else 0f)
                    )
                }
            }
        }
        AppDropdownMenu(
            expanded = expanded,
            onDismissRequest = onDismissExpanded,
            modifier = Modifier.widthIn(min = 260.dp, max = 420.dp),
            containerColor = StaffSurface,
            shape = RoundedCornerShape(14.dp),
            border = BorderStroke(1.dp, StaffBorder),
            shadowElevation = 16.dp
        ) {
            options.forEach { option ->
                DropdownMenuItem(
                    text = { Text(option.label, color = StaffNavy) },
                    onClick = {
                        onSelectedIdsChanged(
                            if (option.id in selectedIds) selectedIds - option.id else selectedIds + option.id
                        )
                    },
                    leadingIcon = {
                        Checkbox(checked = option.id in selectedIds, onCheckedChange = null)
                    }
                )
            }
        }
    }
}

@Composable
private fun StaffFormField(
    label: String,
    required: Boolean = false,
    error: String = "",
    field: @Composable () -> Unit
) {
    AppDialogFieldColumn(
        label = label,
        required = required,
        error = error,
        colors = StaffDialogColors,
        field = field
    )
}

@Composable
internal fun StaffViewModal(
    open: Boolean,
    row: StaffRowUi?,
    onClose: () -> Unit
) {
    if (!open || row == null) return

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Wide,
        colors = StaffDialogColors,
        maxDialogHeight = 820.dp,
        fillDialogHeight = true
    ) {
        AppDialogHeader(
            title = "View Staff",
            subtitle = "Staff member details and assignment information",
            onClose = onClose,
            colors = StaffDialogColors,
            icon = null
        )
        HorizontalDivider(color = StaffBorder)
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 24.dp, vertical = 20.dp),
            verticalArrangement = Arrangement.spacedBy(18.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                StaffAuditCell("Created by", row.createdBy, Modifier.weight(1f))
                StaffAuditCell("Created", row.createdAt.toStaffDisplayDateTime().ifBlank { "15 May 2024, 10:30 AM" }, Modifier.weight(1f))
                StaffAuditCell("Last modified by", row.updatedBy, Modifier.weight(1f))
                StaffAuditCell("Last modified", row.updatedAt.toStaffDisplayDateTime().ifBlank { "28 May 2024, 04:45 PM" }, Modifier.weight(1f))
            }
            HorizontalDivider(color = StaffBorder)
            Text("Staff Information", color = StaffNavy, fontSize = 16.sp, fontWeight = FontWeight.SemiBold)
            HorizontalDivider(color = StaffBorder)
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                    StaffInfoCell("Staff ID", row.staffId, Modifier.weight(1f))
                    StaffInfoCell("Staff Name", row.staffName, Modifier.weight(1f))
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                    StaffInfoCell("Staff Role", row.roleTitle.ifBlank { staffRoleLabel(row.staffRole) }, Modifier.weight(1f))
                    StaffInfoCell("Auth Role", staffAuthRoleDisplayLabel(row.authRoleCode, row.authRole), Modifier.weight(1f))
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                    StaffInfoCell("Mobile Number", row.mobileNumber, Modifier.weight(1f))
                    StaffInfoCell("Gender", staffGenderLabel(row.gender), Modifier.weight(1f))
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                    StaffInfoCell("Email Address", row.emailAddress, Modifier.weight(1f))
                    Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        Text("Status", color = StaffNavy, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
                        StaffStatusChip(row.status)
                    }
                }
            }
            HorizontalDivider(color = StaffBorder)
            Text("Teaching Assignments", color = StaffNavy, fontSize = 16.sp, fontWeight = FontWeight.SemiBold)
            if (row.viewAssignments.isEmpty()) {
                Text(
                    "No teaching or class teacher assignments are assigned to this staff member.",
                    color = StaffMuted,
                    fontSize = 14.sp
                )
            } else {
                val subjectAssignments = row.viewAssignments.filterNot { it.isClassTeacher }
                val classTeacherClasses = row.viewAssignments
                    .filter { it.isClassTeacher }
                    .map { it.classLabel }
                    .distinct()

                if (subjectAssignments.isNotEmpty()) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .border(1.dp, StaffBorder, RoundedCornerShape(8.dp))
                    ) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .background(StaffBlueBg)
                                .padding(horizontal = 14.dp, vertical = 10.dp),
                            horizontalArrangement = Arrangement.spacedBy(16.dp)
                        ) {
                            Text("Class - Section", modifier = Modifier.weight(1f), color = StaffNavy, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
                            Text("Subject", modifier = Modifier.weight(1f), color = StaffNavy, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
                        }
                        subjectAssignments.forEach { assignment ->
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(horizontal = 14.dp, vertical = 10.dp),
                                horizontalArrangement = Arrangement.spacedBy(16.dp)
                            ) {
                                Text(assignment.classLabel, modifier = Modifier.weight(1f), color = StaffNavy, fontSize = 14.sp)
                                Text(assignment.subjectLabel, modifier = Modifier.weight(1f), color = StaffNavy, fontSize = 14.sp)
                            }
                        }
                    }
                }

                if (classTeacherClasses.isNotEmpty()) {
                    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        Text("Class Teacher", color = StaffNavy, fontSize = 14.sp, fontWeight = FontWeight.SemiBold)
                        classTeacherClasses.forEach { classLabel ->
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .border(1.dp, StaffBorder, RoundedCornerShape(8.dp))
                                    .padding(horizontal = 14.dp, vertical = 12.dp),
                                horizontalArrangement = Arrangement.spacedBy(8.dp)
                            ) {
                                Text("Class teacher for", color = StaffMuted, fontSize = 14.sp)
                                Text(classLabel, color = StaffNavy, fontSize = 14.sp, fontWeight = FontWeight.Medium)
                            }
                        }
                    }
                }
            }
        }
        AppDialogFooter(
            actions = listOf(AppDialogFooterAction("Close", onClose, AppDialogActionStyle.Primary, width = 104.dp)),
            colors = StaffDialogColors
        )
    }
}

@Composable
private fun StaffAuditCell(label: String, value: String, modifier: Modifier = Modifier) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(4.dp)) {
        Text(label, color = StaffMuted, fontSize = 12.sp, fontWeight = FontWeight.SemiBold)
        Text(value.ifBlank { "—" }, color = StaffMuted, fontSize = 12.sp, fontWeight = FontWeight.Normal, maxLines = 2, overflow = TextOverflow.Ellipsis)
    }
}

@Composable
private fun StaffInfoCell(label: String, value: String, modifier: Modifier = Modifier) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = StaffNavy, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
        Text(value.ifBlank { "—" }, color = StaffNavy, fontSize = 14.sp, fontWeight = FontWeight.Normal, maxLines = 2, overflow = TextOverflow.Ellipsis)
    }
}

private data class StaffChipColors(
    val content: Color,
    val background: Color
)

private fun staffTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    // Keep shimmer weights identical to StaffTableHeader and StaffRow so loading
    // placeholders do not drift across the table.
    AdminListHeaderColumn(label = "Staff ID", weight = 1.05f),
    AdminListHeaderColumn(label = "Staff Name", weight = 1.45f),
    AdminListHeaderColumn(label = "Staff Role", weight = 1.1f),
    AdminListHeaderColumn(label = "Auth Role", weight = 1.0f),
    AdminListHeaderColumn(label = "Mobile Number", weight = 1.25f),
    AdminListHeaderColumn(label = "Status", weight = 0.8f),
    AdminListHeaderColumn(label = "Actions", weight = 0.95f, alignCenter = true)
)

private enum class StaffPendingActionType {
    Delete,
    ToggleStatus
}

private data class StaffPendingAction(
    val staff: StaffRowUi,
    val action: StaffPendingActionType
)
